export default {
  languageDesc: '简体中文',
  demoAndDocument: '实例 / 文档',
  changeLog: '更新日志',
  project: '项目',
  language: '语言',
  jqSeries: 'jQuery 系列插件',
  jqVersion: 'jQuery 版本',
  homePageTitle: 'Terry <strong>Vue</strong> 插件系列',

  install: '安装插件',
  deploy: '在页面 / 模块中使用',
  example: '实例',
  options: '入参选项',
  events: '响应事件',
  codePen: '在 <strong>CodePen</strong> 上查看实例',
  showHideCode: '显示/隐藏 代码',
  selectedResults: '选择结果数据',
  globalConfig: '可在插件注册时进行全局配置的参数',

  guide: {
    useNpm: '使用<strong class="px-2">npm</strong>把插件安装到项目中',
    include: '在项目入口<code class="px-2">main.js</code>中引入插件',
    customRegister: '自定义全局注册组件',
    useGlobalComponent: '使用全局注册的组件',
    useLocalComponent: '使用本地注册的组件'
  },
  tbTitle: {
    name: '选项名',
    type: '类型',
    desc: '参数描述',
    required: '必填',
    default: '默认值',
    args: '返回数据',
    scope: '范围',
    param: '参数名',
    prop: '属性名',
    apiName: '函数名'
  },
  lang: {
    desc: '插件国际化 i18n 的使用语言',
    cn: '中文',
    en: '英文',
    jp: '日文',
    ar: '阿拉伯文',
    es: '西班牙文',
    de: '德文',
    ro: '罗马尼亚文',
    fr: '法文',
    pt_br: '葡萄牙语(巴西)',
    pl: '波兰语',
    fa: '波斯语'
  }
}
